import { Dialog, Transition } from '@headlessui/react';
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IconAdjustmentsHorizontal, IconX, IconTrash, IconXboxX } from '@tabler/icons-react';
import LoadingIndicator from '../LoadingIndicator';

export default function PindahBarangBanyak({
  setOpenPindahBanyakBarang,
  refreshPage,
  reloadDate,
  openPindahBarangBanyak,
  cabang,
  setSelectedItems,
  selectedItems,
  resetSelectPindahItems,
  closeModalBanyakBarang,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const ids = selectedItems.map((item) => item.id);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);


  useEffect(() => {
    async function getCabangSelect() {
      await http
        .get(`cabang/brankas`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setSelectCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getCabangSelect();
  }, [navigate]);

  const [cabangId, setCabangId] = useState(0);

  async function handleSubmitBrankasToEtalase(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      items: ids,
      cabang_id: cabangId
    }
    if (cabangId !== 0) {
      try {
        const response = await http.post('/item/pindah_etalase', formData, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        // console.log(response.data)
        toast.success('Data berhasil dipindah', { autoClose: 600, });
        setOpenPindahBanyakBarang(false);
        reloadDate();
        setLoading(false);
        resetSelectPindahItems();
        return response.data
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error('Pilih toko dulu', { autoClose: 600, });
    }
    setLoading(false);
  }
  async function handleSubmitPindahBarang(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      cabang_id: idCabang,
      items: ids,
    };
    if (idCabang !== 0) {
      try {
        const response = await http.post('/item/transfer', formData, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        // console.log(response.data)
        toast.success('Data berhasil dipindah', { autoClose: 600, });
        setOpenPindahBanyakBarang(false);
        refreshPage();
        setLoading(false);
        return response.data
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error('Pilih cabang tujuan', { autoClose: 600, });
    }
    setLoading(false);
  }
  function fake() { }
  function removeSelectedItem(itemId) {
    setSelectedItems(currentItems => currentItems.filter(item => item.id !== itemId));
  }
  return (
    <>
      {loading &&
        <LoadingIndicator />
      }
      <Transition appear show={openPindahBarangBanyak} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={fake}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden bg-white sm:rounded-2xl p-0 text-left align-middle shadow-xl transition-all flex flex-col max-h-[90vh]">
                  {/* Header */}
                  <div className="px-5 py-4 border-b border-slate-200 bg-white flex items-center justify-between sticky top-0 z-10 w-full">
                    <div>
                      <Dialog.Title as="h2" className="text-lg sm:text-xl font-bold text-slate-800">
                        Pindah ke Etalase / Brankas
                      </Dialog.Title>
                      <p className="text-sm text-slate-500 mt-0.5">Memindahkan {ids?.length} barang sekaligus</p>
                    </div>
                    <button
                      onClick={closeModalBanyakBarang}
                      className="p-2 rounded-full hover:bg-slate-100 text-slate-500 transition-colors"
                    >
                      <IconX className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Body / Scrollable Content */}
                  <div className="p-5 overflow-y-auto flex-1 bg-slate-50/50">
                    <div className="bg-white border text-center border-slate-200 rounded-xl overflow-hidden shadow-sm">
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left text-slate-600">
                          <thead className="text-xs text-slate-500 uppercase bg-slate-50 border-b border-slate-200">
                            <tr>
                              <th scope="col" className="px-4 py-3 font-semibold w-12 text-center">No</th>
                              <th scope="col" className="px-4 py-3 font-semibold border-l border-slate-200 align-middle">Kode</th>
                              <th scope="col" className="px-4 py-3 font-semibold border-l border-slate-200 align-middle">Barang</th>
                              <th scope="col" className="px-4 py-3 font-semibold border-l border-slate-200 text-right align-middle">Berat</th>
                              <th scope="col" className="px-4 py-3 font-semibold border-l border-slate-200 text-center w-20">Aksi</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                            {selectedItems?.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="px-4 py-8 text-center text-slate-400">Belum ada barang dipilih</td>
                              </tr>
                            ) : (
                              selectedItems?.map((bt, i) => (
                                <tr key={i} className="hover:bg-amber-50/50 transition-colors bg-white">
                                  <td className="px-4 py-2.5 text-center text-slate-400">{i + 1}</td>
                                  <td className="px-4 py-2.5 font-medium border-l border-slate-200 align-middle text-slate-700">{bt?.kode_item}</td>
                                  <td className="px-4 py-2.5 border-l border-slate-200 align-middle text-slate-600">{bt?.jenis_kategori?.nama_jenis}</td>
                                  <td className="px-4 py-2.5 border-l border-slate-200 align-middle text-right tabular-nums text-slate-700">{bt?.berat} gr</td>
                                  <td className="px-4 py-2.5 border-l border-slate-200 align-middle text-center">
                                    <button
                                      type="button"
                                      onClick={() => removeSelectedItem(bt.id)}
                                      className="inline-flex items-center justify-center w-8 h-8 rounded-lg text-red-500 hover:bg-red-50 hover:text-red-600 transition-colors"
                                      title="Batal Pindah"
                                    >
                                      <IconTrash className="w-4 h-4" />
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="mt-6">
                      <div className="relative">
                        <select
                          onChange={(e) => setCabangId(e.target.value)}
                          required
                          className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none shadow-sm"
                          style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                        >
                          <option value="">Pilih brankas atau etalase...</option>
                          {cabang?.map((cb) => (
                            <option value={cb.id} key={cb.id}>
                              {cb?.nama_cabang}
                            </option>
                          ))}
                        </select>
                        <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-600">Tujuan Pindah</label>
                      </div>
                    </div>
                  </div>

                  {/* Footer / Actions */}
                  <div className="px-5 py-4 border-t border-slate-200 bg-white flex flex-col sm:flex-row justify-end gap-3 sticky bottom-0 w-full z-10">
                    <button
                      type="button"
                      disabled={loading}
                      onClick={closeModalBanyakBarang}
                      className="flex-1 sm:flex-none h-12 sm:h-10 px-6 inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 active:bg-slate-300 transition-colors disabled:opacity-50"
                    >
                      Batal
                    </button>
                    <button
                      type="button"
                      disabled={loading || selectedItems?.length === 0 || !cabangId}
                      onClick={handleSubmitBrankasToEtalase}
                      className="flex-[2] sm:flex-none h-12 sm:h-10 px-8 inline-flex items-center justify-center gap-2 rounded-lg font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 shadow-md shadow-amber-500/20 transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:cursor-not-allowed"
                    >
                      {loading ? (
                        <>
                          <div className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          <span>Memproses...</span>
                        </>
                      ) : (
                        <>
                          <IconAdjustmentsHorizontal className="w-5 h-5" />
                          <span>Pindah Barang</span>
                        </>
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
